import { render, staticRenderFns } from "./drag-and-match.vue?vue&type=template&id=61448652&scoped=true&"
import script from "./drag-and-match.vue?vue&type=script&lang=js&"
export * from "./drag-and-match.vue?vue&type=script&lang=js&"
import style0 from "./drag-and-match.vue?vue&type=style&index=0&id=61448652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61448652",
  null
  
)

export default component.exports